module.exports = __webpack_public_path__ + "assets/icons/ic_edit_24px.svg";